/**
 * Zone.js event patching configuration.
 * Must be loaded BEFORE zone.js (imported in polyfills.ts).
 *
 * Mouse tracking events (mousemove, mouseover, mouseenter, pointermove, pointerover)
 * are excluded from Zone.js patching because they fire at high frequency and each one
 * triggers Angular change detection → SVGIconComponent re-render → forced layout (~290ms).
 * This creates a feedback loop where 12+ layouts block the main thread for 4+ seconds
 * on a simple hover or scroll over a Kendo grid.
 *
 * scroll is also excluded because ResizeObserver/scroll handlers should run outside zone.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, camelcase -- Zone.js API requires this exact global name
(window as any).__zone_symbol__UNPATCHED_EVENTS = [
  'mousemove',
  'mouseover',
  'mouseout',
  'mouseenter',
  'mouseleave',
  'pointermove',
  'pointerover',
  'pointerout',
  'pointerenter',
  'pointerleave',
  'scroll',
];
